import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { LOGIN_SIDE_CAROUSEL_SLIDES } from "../../utility/constants/authUi";
import { autoPlayKeenSlider } from "./hooks/useAutoPlayKeenSlider";

const CAROUSEL_INTERVAL_MS = 5000;

const LoginSideCarousel = () => {
  const [sliderRef] = useKeenSlider({ initial: 0, loop: true }, [autoPlayKeenSlider(CAROUSEL_INTERVAL_MS)]);

  return (
    <div className="login-side-carousel">
      <div ref={sliderRef} className="keen-slider">
        {LOGIN_SIDE_CAROUSEL_SLIDES.map((slide) => (
          <div key={slide.id} className="keen-slider__slide login-side-carousel__slide">
            <img src={slide.src} alt={slide.alt} className="login-side-carousel__img" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoginSideCarousel;
